import {  withStyles } from '@material-ui/core';
import TextFieldMultiLine from "@mui/material/TextField";
const CustomTextField = (props) => <TextFieldMultiLine {...props} disabled />
const DisabledMultiLineTextField = withStyles({
root: {
"& .MuiInputBase-root.Mui-disabled": {
    color: "rgba(0, 0, 0,1)"
},
"& .MuiFormLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0,1)",
    
},
"& .MuiInputBase-inputMultiline.Mui-disabled": {
    "-webkit-text-fill-color": "rgba(0, 0, 0,1)",
},

}
})(CustomTextField);
export default DisabledMultiLineTextField